/**
 * See /.env
 */
export interface IConfig {
  REACT_APP_APIV4_BASE_URL: string;
  REACT_APP_FE_BASE_URL: string;
  REACT_APP_IDENTITY_API_HOST: string;
}

export const config: IConfig = {
  REACT_APP_APIV4_BASE_URL: process.env.REACT_APP_APIV4_BASE_URL || "",
  REACT_APP_FE_BASE_URL: process.env.REACT_APP_FE_BASE_URL || "",
  REACT_APP_IDENTITY_API_HOST: process.env.REACT_APP_IDENTITY_API_HOST || "",
};
